import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { CONSTANTS } from '../../constants'
import { baseQueryConfigured } from '../../plugins/rtk-query.config'
import { CommentContextType, Tag } from '../../types'

export const tagsApi = createApi({
  reducerPath: 'tagsApi',
  baseQuery: baseQueryConfigured,
  tagTypes: ['Tags'],
  endpoints: (builder) => ({
    getTagsByContextType: builder.query<Tag[], string>({
      query: (contextType: CommentContextType) => ({
        url: `${CONSTANTS.API.TAGS}?context_type=${contextType}`,
      }),
      providesTags: ['Tags'],
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetTagsByContextTypeQuery } = tagsApi
